import { ChainId } from '../types';
import { NATIVE_TOKEN_ADDRESS } from './constants';
export const ADDRESS_BY_CHAIN_CRONOS_EVM = {
    [ChainId.CRONOS_EVM_MAINNET]: {
        WCRO: NATIVE_TOKEN_ADDRESS,
        LiquidCro: '0x9fae23a2700feecd5b93e43fdbc03c76aa7c08a6',
        PrelaunchDeposit: '0x76bf2D1e6dFda645c0c17440B17Eccc181dfC351',
        LCroBridge: '0x28ff2e4dd1b58efeb0fc138602a28d5ae81e44e2',
        FUL: '0x83aFB1C32E5637ACd0a452D87c3249f4a9F0013A',
        MERY: '0x3b41B27E74Dd366CE27cB389dc7877D4e1516d4d',
        ETH: '0xe44fd7fcb2b1581822d0c862b68222998a0c299a',
        USDC: '0xc21223249CA28397B4B6541dfFaEcC539BfF0c59',
    },
    [ChainId.CRONOS_EVM_TESTNET]: {
        WCRO: NATIVE_TOKEN_ADDRESS,
        LiquidCro: '0x612f914109fc24f3aaa200b27ee19c79a3426850',
        PrelaunchDeposit: '0x2656538b50E66778bc4aDA7fCc50738B9D5Fb722',
        LCroBridge: '0xde874fcaa1caf96d8bd1fda23a70af1244230aae',
        FUL: '0x2e755Bf30938B64281900d2219C3842d509e9D92',
        MERY: '',
        ETH: '0x441d72d584b16105FF1C68DC8bc4517F4DC13E55',
        USDC: '0x321106E51b78E0E9CEBcFeC63C5250F0F3CcB82b',
    },
};
